import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-admin-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class AdminFooterComponent {
  @Input() customClass: string;

  openCookieSettings() {
    (window as any).OneTrust.ToggleInfoDisplay();
  }
}
